<template>
  <div class="rules container d-flex flex-column">
    <Logged-user />
    <div class="row mt-2">
      <img src="/static/bibliotheque.jpeg" width="100%" class="col-md-12"/>
    </div>
     <div class="row mt-4">
      <h1 class="col-12 h2">
        Règle du scrabble duplicate et fonctionnement de Lettre Compte Triple.
      </h1>
     </div>
    <div class="row mt-4">
      <div class="col-12 col-lg-6">
        <h2>
          <img src="/static/feather.svg" class="icon" width="30"/>Règle du Scrabble duplicate
        </h2>
        <h3 id="generalite">Généralités</h3>
        <p>
          Le Scrabble Duplicate est un mode de jeu dans lequel le facteur chance n'existe pas.<br />
          En effet à tout moment de la partie les joueurs
          ont le même plateau et les mêmes lettres en mains.<br />
          <br />
          Le Scrabble Duplicate est donc le mode de jeu adopté dans les tournois de Scrabble.<br />
          Sur www.lettrecomptetriple.org on vous propose de vous entrainer au Scrabble Duplicate
        </p>
        <h3 id="composition">Composition du jeu</h3>
        <p>
          Chaque joueur doit posseder en début de partie un plateau et l'ensemble des 100 lettres
          et des 2 jokers qui composent le jeu.<br />
        </p>
        <h3 id="leplateau">Le plateau</h3>
        <div>
          Le plateau est composé de 225 cases dont certaines ont un comportement spécial:<br />
          <dl>
            <dt>Mot compte triple</dt>
            <dd>Les meilleures cases du jeu ! L'intégralité des points du mot sont multipliés
              par 3</dd>
            <dt>Mot compte double</dt>
            <dd>L'intégralité des points du mot sont doublés</dd>
            <dt>Lettre compte triple</dt>
            <dd>Les points de la lettre placé sur la case sont triplés</dd>
            <dt>Lettre compte double</dt>
            <dd>Les points de la lettre placé sur la case sont doublés</dd>
          </dl>
        </div>
        <h3 id="debut">Début</h3>
        <p>
          Au début du jeu, chaque joueur reçoit les mêmes 7 lettres.
        </p>
        <h3 id="deroulement">Déroulement</h3>
        <p>
          Chaque tour est chronométré, lorsque le chronomètre est à 0 le tour s'arrête.<br/>
          Pendant le tour chaque joueur essaie de former le mot comptant le plus de points
          sur le plateau.
          <br />
          A l'issu du tour, chaque joueur marque les points du meilleur mot qu'il a trouvé.
          <br />
          Ensuite on détermine quel est le meilleur mot trouvé parmi l'ensemble des joueurs.
          <br />
          C'est ce mot que chacun mettra sur le plateau.
          <br />
          Enfin chaque joueur reçoit à nouveau les mêmes 7 lettres et le tour suivant démarre.
        </p>
        <h3 id="joker">Joker</h3>
        <p>Le joker peut remplacer n'importe quelle lettre. Un fois qu'il est posé sur le
          plateau il a la valeur de la lettre qu'il remplace.
          <br />
          Le Joker ne compte pas de point.
        </p>
        <h3 id="mots">Les mots autorisés</h3>
        <p>C'est le dictionnaire "ODS" (Officiel du Scrabble) qui fait foi.
          <br />
          D'une manière générale le Scrabble autorise l'ensemble des mots de la langue française,
          au singulier comme au pluriel, au masculin et au féminin. Les verbes peuvent être
          à l'infinitif ou conjugués.
          <br />
          Ne sont pas autorisés les expression composées, les sigles et abréviations, les
          symboles chimiques et les noms propres.
        </p>
        <h3 id="calcule">Calcul des points</h3>
        <p>
          Chaque lettre posée compte pour la valeur qui est marquée dessus.<br />
          On compte l'intégralité des mots formés par les lettres que l'on vient de poser.<br />
          Si une lettre que l'on pose forme 2 mots, elle est comptée deux fois (si en plus elle
          est sur une case spéciale, celle-ci est comptée pour les 2 mots).
          <br />
          Les cases spéciales ne s'appliquent qu'aux lettes que l'on pose. On applique d'abord
          les cases "lettre compte double" et "lettre compte triple" avant d'appliquer
          "mot compte double" et "mot compte triple".
          <br />
          Un bonus de 50 points est accordé au coup si le joueur pose 7 lettres.
        </p>
        <h3 id="victoire">La victoire</h3>
        <p>
          Le jeu se termine lorsqu'il n'y a plus qu'une lettre à poser ou qu'il ne reste que
          des voyelles ou que des consonnes.<br />
          Le joueur ayant additionné le plus de points est alors déclaré vainqueur.
        </p>
        <h3 id="conclusion">Conclusion</h3>
        <p>
          Les règles du Scrabble sur le papier ne sont pas simples à comprendre. Cependant
          elles deviennent évidentes dès que l'on joue.
          <br />
          Alors pourquoi ne pas essayer le Scrabble Duplicate tout de suite !
        </p>
      </div>

      <div class="col-12 col-lg-6">
        <h2><img src="/static/info.svg" class="icon" width="30"/>  Aide Lettre Compte Triple</h2>
        <h3>Comment jouer ?</h3>
        <p>
          Clique sur les lettres du support en dessous du plateau et tout en maintenant
          le bouton de la souris enfoncé, fais les glisser sur le plateau.<br />
          Lorsque le <strong>joker</strong> apparaît, clique sur le sigle "?", une petite fenêtre
          apparaît te permettant de sélectionner la lettre que tu veux.<br />
          Lorsqu'un mot est bien placé sur le plateau, il est automatiquement validé.<br />
          A la fin du tour, le joueur marque le meilleur mot qu'il a trouvé.<br /><br />
          <strong>Contrôles avancés et astuces</strong><br />
          Autour du support des lettres il y a 3 boutons : <br />
          <img src="/static/next-alt.svg" class="icon"/> permet de ramener sur le support
          les lettres déposées sur le plateau. <br />
          <img src="/static/shuffle.svg" class="icon"/> permet de mélanger les lettres.<br />
          <img src="/static/swap-vertical.svg" class="icon" title="Changer la disposition"/> permet
          de changer la disposition (support au dessus ou en dessous du plateau)<br />
          <br />
          Sous le support des lettres, un champ de saisie permet d'écrire au clavier le mot.
          Cela va plus vite !<br /><br />
          Le joker s'écrit en entourant la lettre de parenthèses.
          Cependant si l'on tape une lettre ne faisant
          pas partie du tirage, alors la lettre joker est automatiquement
          remplacée par cette lettre.<br />
          Un clic sur une case du plateau (clic gauche) permet de définir
          la première case du mot à poser,
          un nouveau clic permet d'intervertir le sens (horizontal / vertical) du mot.
          <br />
        </p>
        <h3>Fonctionnement des parties</h3>
        <p>
          Les parties se déroulent jusqu'à ce qu'il n'y ait plus de lettre dans le sabot.<br />
        </p>
        <p>
          Le top posé est choisi arbitrairement par l'ordinateur sur la
          base de critères permettant d'ouvrir le jeu.<br />
        </p>
        <h3>Calcul des scores</h3>
        <p>
          Les <strong>scores</strong> ne sont comptabilisés que lorsque le joueur a fait un minimum
          de 400 points.<br />
          Le score du classement LCT est en fonction de ta position à la fin de la partie. Plus
          il y a de joueurs contre toi, plus tu marques de points.<br />
          Lorsque tu as fait une partie, tu apparaîs dans le classement des joueurs.
        </p>
        <h3>Le top</h3>
        <p>
          Le top est le meilleur mot possible calculé par l'ordinateur. Dans le tableau de score on
          voit le "% du top" c'est le nombre de points que tu as marqué par rapport à l'ordinateur.
          Si tu as trouvé tous les meilleurs mots, ton pourcentage sera de 100%.<br />
          Les meilleurs joueurs arrivent à marquer jusqu'à 95% du top.<br />
          Un bonus de 10 points est attribué au joueur s'il est le seul à avoir trouvé
          le plus haut score parmi les joueurs,
          même si ce n'est pas le top! ( Il faut qu'il y ait au moins 16 joueurs
          dans la partie pour que ce bonus soit accordé).
        </p>
        <h3>Le pastillage</h3>
        <p>
          Cette fonctionnalité n'est accessible qu'aux adhérents de LCT.
          Elle permet, via un clic droit sur une case du plateau d'ajouter
          une petite pastille.<br />
          La pastille est utilisée par les joueurs comme un moyen mémo technique des
          rallonges possibles.
        </p>
        <h3>Blocages et troubles</h3>
        <p>
          Il peut arriver que le jeu se bloque. Dans ce cas, il faut appuyer sur les touches CTRL
          et F5 en même temps.<br />
          Pour une meilleure expérience de jeu nous te conseillons vivement d'utiliser
          <a href="http://www.google.fr/chrome/">Chrome</a>, le navigateur de Google qui est
          clairement le plus performant du moment.<br />
        </p>
        <h3>Je ne vois pas tout le plateau, que faire?</h3>
        <p>
          - Première solution : en appuyant sur la touche F11 du clavier le navigateur passe
          en mode "plein écran".
          Pour revenir en mode normal, il faut appuyer une nouvelle fois sur F11.<br />
          - Seconde solution : changer le zoom du navigateur et le mettre à 80%.
        </p>
      </div>
    </div>
    <div class="mt-auto">
      <bottom-nav />
    </div>
  </div>
</template>

<script>
import LoggedUser from './LoggedUser.vue';
import BottomNav from './BottomNav.vue';

export default {
  name: 'Rules',
  components: { LoggedUser, BottomNav },
};
</script>

<style scoped>
.rules {
  font-size: 0.95rem;
}
.rules p {
  text-align: justify;
}
.rules h2{
    font-size: 1.6rem;
}
.rules h3 {
    font-size: 1rem;
    margin-top: 2.5rem;
    color: #5dc596;
}
.icon{
  vertical-align: top;
  width: 24px;
}
</style>
